import { render, staticRenderFns } from "./PanelCompetitionDashboard.vue?vue&type=template&id=1746d308&scoped=true&"
import script from "./PanelCompetitionDashboard.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionDashboard.vue?vue&type=style&index=0&id=1746d308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746d308",
  null
  
)

export default component.exports